import { ref } from 'vue';

import { useDialog } from '@/shared/composables/useDialog';

import {

    persistMyCorporateBranchAddresses,

    type MyCorporateBranchAddressLists,

} from '../utils/persistMyCorporateBranchAddresses';

import {

    persistMyRegisterContactAddresses,

    type MyRegisterAddressDeleteContext,

} from '@/features/register/MY/utils/persistMyRegisterContactAddresses';



export type { MyRegisterAddressDeleteContext };



const DELETE_CONFIRM_MESSAGE = 'Are you sure you want to delete this address?';



export function useMyCorporateBranchAddressDelete(options: {

    getContactCd: () => string;

    getRegisterAddressDeleteContext?: () => MyRegisterAddressDeleteContext | null | undefined;

    getContactListFlatAddressMode?: () => boolean;

    onRefreshed?: () => void | Promise<void>;

}) {

    const deletingKey = ref<string | null>(null);

    const { deleteConfirm, error: errorDialog } = useDialog();



    function isDeleting(key: string): boolean {

        return deletingKey.value === key;

    }



    /**

     * @param persistToServer false — + Add 직후 미저장 draft 행만 로컬 제거

     */

    async function confirmAndDeleteBranchAddress(

        key: string,

        lists: MyCorporateBranchAddressLists,

        persistToServer: boolean,

    ): Promise<boolean> {

        const ok = await deleteConfirm(DELETE_CONFIRM_MESSAGE);

        if (!ok) return false;



        if (!persistToServer) return true;



        const registerCtx = options.getRegisterAddressDeleteContext?.() ?? null;

        if (registerCtx) {

            deletingKey.value = key;

            try {

                await persistMyRegisterContactAddresses(registerCtx, lists);

                await options.onRefreshed?.();

                return true;

            } catch (err: any) {

                const msg =

                    err?.response?.data?.error?.message ||

                    err?.response?.data?.message ||

                    err?.message ||

                    'Failed to delete address.';

                await errorDialog('Error', msg);

                return false;

            } finally {

                deletingKey.value = null;

            }

        }



        const cd = String(options.getContactCd() || '').trim();

        if (!cd) {

            await errorDialog('Error', 'Contact ID is missing.');

            return false;

        }



        deletingKey.value = key;

        try {

            await persistMyCorporateBranchAddresses(cd, lists, {

                contactListFlatAddressMode: options.getContactListFlatAddressMode?.() ?? false,

            });

            await options.onRefreshed?.();

            return true;

        } catch (err: any) {

            const msg =

                err?.response?.data?.error?.message ||

                err?.response?.data?.message ||

                err?.message ||

                'Failed to delete address.';

            await errorDialog('Error', msg);

            return false;

        } finally {

            deletingKey.value = null;

        }

    }



    return {

        deletingKey,

        isDeleting,

        confirmAndDeleteBranchAddress,

    };

}

